import { render, staticRenderFns } from "./TeksListSetter.vue?vue&type=template&id=a22a6722&"
import script from "./TeksListSetter.vue?vue&type=script&lang=js&"
export * from "./TeksListSetter.vue?vue&type=script&lang=js&"
import style0 from "./TeksListSetter.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TeksListSetter.vue"
export default component.exports